import DashboardIcon from "@material-ui/icons/DashboardRounded";
import UsersIcon from "@material-ui/icons/GroupRounded";
import DataIcon from "@material-ui/icons/PieChartRounded";
import ReportingIcon from "@material-ui/icons/BarChartRounded";
import LaunchIcon from "@material-ui/icons/Launch";
import SettingsIcon from "@material-ui/icons/SettingsRounded";
import { NavItemProps } from "./NavItem/NavItem";
import HelpOutline from "@material-ui/icons/HelpOutline";
import InternalRoutes from "Shared/Constants/InternalRoutes";
import { DollarIcon, RewardIcon } from "Components/Icons";

const navItems: NavItemProps[] = [
  {
    kind: "solo",
    label: "Home",
    to: InternalRoutes.dashboard,
    exact: true,
    Icon: DashboardIcon,
  },

  {
    kind: "solo",
    label: "Users",
    to: InternalRoutes.users,
    Icon: UsersIcon,
  },

  {
    kind: "parent",
    label: "Reporting",
    permission: "canViewReports",
    Icon: ReportingIcon,
    childProps: [
      {
        label: "Enrollment",
        to: InternalRoutes.enrollmentReport,
        featureFlag: "provider_metabase_report",
        permission: "canViewMetabaseReports",
      },
      {
        label: "Usage",
        to: InternalRoutes.usageReport,
        featureFlag: "provider_metabase_report",
        permission: "canViewMetabaseReports",
      },
      {
        label: "Compliance",
        to: InternalRoutes.complianceReports,
        featureFlag: "provider_compliance_reports",
        permission: "canViewComplianceReports",
      },
      {
        label: "Payday Exclusions",
        to: InternalRoutes.presettlementExclusions,
        featureFlag: "provider_presettlement_exclusions_reports",
        permission: "canViewPresettlementExclusionReports",
      },
      {
        label: "Balance Distributor",
        to: InternalRoutes.balanceDistributorReport,
        featureFlag: "provider_balance_distributor_report",
        permission: "canViewPayrollExtenderReports",
        otherConditionals: ["balanceDistributorOptions.enabled"],
      },
      {
        label: "Other",
        to: InternalRoutes.otherReports,
      },
    ],
  },

  {
    kind: "parent",
    label: "Data Exchange",
    permission: "canViewDataExchange",
    Icon: DataIcon,
    childProps: [
      {
        label: "User Roster",
        to: InternalRoutes.roster,
      },
      {
        label: "Gross Earnings",
        to: InternalRoutes.grossEarnings,
        permission: "canListGrossEarnings",
      },
      {
        label: "Net Earnings",
        to: InternalRoutes.netEarnings,
        permission: "canListNetEarnings",
      },
      {
        label: "Direct Deposit Update",
        to: InternalRoutes.directDeposit,
      },
    ],
  },

  {
    kind: "parent",
    label: "CYCLE",
    permission: "canViewReports",
    Icon: DollarIcon,
    childProps: [
      {
        label: "File Upload",
        to: InternalRoutes.disbursementsFileUpload,
        permission: "canListBatchDisbursements",
        otherConditionals: [
          "offCyclePaymentOptions.enableBatchOffCycleDisbursements",
        ],
      },
      {
        label: "Report",
        to: InternalRoutes.disbursementsReport,
        permission: "canViewCycleReports",
        otherConditionals: [
          "offCyclePaymentOptions.enableOffCycleDisbursements",
        ],
      },
    ],
  },

  {
    kind: "parent",
    label: "REWARD",
    permission: "canListRewards",
    Icon: RewardIcon,
    childProps: [
      {
        label: "REWARD Setup",
        to: InternalRoutes.rewardsSetup,
        otherConditionals: ["rewardsOptions.enableRewards"],
      },
      {
        label: "Report",
        to: InternalRoutes.rewardsReport,
        otherConditionals: ["rewardsOptions.enableRewards"],
      },
    ],
  },

  {
    kind: "parent",
    label: "Configuration",
    Icon: SettingsIcon,
    childProps: [
      {
        label: "Admins & Roles",
        to: InternalRoutes.admins,
        permission: "canListAdmins",
      },
      // {
      //   label: "Settings",
      //   to: InternalRoutes.settings,
      //   permission: "canCreateAdmins",
      // },
    ],
  },

  {
    kind: "solo",
    label: "Help & Docs",
    to: InternalRoutes.help,
    Icon: HelpOutline,
  },

  {
    kind: "solo",
    label: "Original Partner Portal",
    to: `${process.env.REACT_APP_RAILS_APP_HOSTNAME}/companies/dashboards`,
    Icon: LaunchIcon,
    featureFlag: "provider_navigation_back_to_partner_portal",
  },
];

export default navItems;
